import { Switch } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";

const PaywallSwitch = ({
	showPaywall,
	toggleShowPaywall,
}: {
	showPaywall: boolean;
	toggleShowPaywall: () => void;
}) => {
	const theme = useAppTheme();
	return (
		<Switch
			value={showPaywall}
			onValueChange={toggleShowPaywall}
			color={theme.colors.secondary}
			aria-checked={showPaywall}
			aria-label="Show paywall switch"
		/>
	);
};

export default PaywallSwitch;
